/* eslint-disable-next-line no-console */
export const logVersion = () => console.log(`version: ${process?.env?.npm_package_version}`);
